import { createSelector } from 'reselect';
import { selectCollectionName } from '@/store/slices/sessionSlice';
export const attributesByCollectionSelector = ({ attributesByCollection }) => attributesByCollection || {};
export const attributeShortSelector = createSelector(attributesByCollectionSelector, selectCollectionName, (attributesByCollection, activeCollection) => {
    var _a;
    if (!activeCollection) {
        return [];
    }
    return (_a = attributesByCollection[activeCollection]) !== null && _a !== void 0 ? _a : [];
});
